
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'ComingSoonBadge',

  props: {
    variant: {
      type: String,
      default: 'floating',
      validator: (v: string) => ['floating', 'inline'].includes(v),
    },
  },

  setup() {
    const { t } = useI18n();
    return { label: t('comingSoon') };
  },
});
